function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { memo, useCallback, useMemo } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { dynamicDateConverters, dynamicDatePresetToDynamicDateRangePreset, dynamicDateRangeValueToDynamicDateValue, dynamicDateValueToDynamicDateRangeValue, fixedDatePresetToFixedDateRangePreset } from './util';
export function withSingleDynamicDate(Component) {
  var _a;

  function Func(props) {
    var dynamicCategories = props.dynamicCategories,
        dynamicPresets = props.dynamicPresets,
        fixedPresets = props.fixedPresets,
        value = props.value,
        onChange = props.onChange,
        onValueChange = props.onValueChange,
        others = _objectWithoutProperties(props, ["dynamicCategories", "dynamicPresets", "fixedPresets", "value", "onChange", "onValueChange"]);

    var dynamicRangePresets = useMemo(function () {
      return dynamicPresets.map(dynamicDatePresetToDynamicDateRangePreset);
    }, [dynamicPresets]);
    var fixedRangePresets = useMemo(function () {
      return (fixedPresets || []).map(fixedDatePresetToFixedDateRangePreset);
    }, [dynamicPresets]);
    var rangeValue = value ? dynamicDateValueToDynamicDateRangeValue(value) : value;
    var onChangeCallback = useRefCallback(onChange);
    var handleChange = useCallback(function (val) {
      onChangeCallback(dynamicDateRangeValueToDynamicDateValue(val));
    }, []);
    var onValueChangeCallback = useRefCallback(onValueChange);
    var handleValueChange = useCallback(function (val) {
      onValueChangeCallback(dynamicDateRangeValueToDynamicDateValue(val));
    }, []);
    var requiredProps = {
      converters: dynamicDateConverters,
      onlyShowStart: true,
      dynamicCategories: dynamicCategories,
      dynamicPresets: dynamicRangePresets,
      fixedPresets: fixedRangePresets,
      value: rangeValue,
      onChange: handleChange,
      onValueChange: handleValueChange
    };
    return React.createElement(Component, Object.assign({}, others, requiredProps));
  }

  Func.displayName = ((_a = Component.displayName) !== null && _a !== void 0 ? _a : Component.name).replace('Range', '');
  return memo(Func);
}